import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { MasterCompany } from 'src/app/Models/master-company';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.css']
})
export class CompanyListComponent implements OnInit,OnChanges {

  @Input() companyList:MasterCompany[];
  @Output() selectedObject= new EventEmitter<MasterCompany>();
  constructor() { }

  ngOnInit(): void {
  }
  changes(obj:MasterCompany,event)
  {
    
    obj.SELECTED=event.target.checked
     this.selectedObject.emit(obj);
  }
  ngOnChanges(changes:SimpleChanges)
  {

  }

}
